function recursive(children) {
  var result = JSON.parse(JSON.stringify(children));
  
  result = result.map((child, index) => {
    var item = child;
    delete item['obj'];
    
    if(item.type === 'playlist') {
      item.children = recursive(item.children);
    }
    
    return item;
  });
  return result;
};

export default function(children) {
  return recursive(children);
};